import request from '@/utils/request'
import qs from "qs";
//获取订单列表
export function userTag(data) {
    return request({
        url: '/user/orderTag',
        method: 'post',
        data: qs.stringify(data)
    })
}
//获取订单详情
export function userDetail(data) {
    return request({
        url: '/user/detail',
        method: 'post',
        data: qs.stringify(data)
    })
}
//获取订单详情--物流信息
//获取订单详情
export function orderExpressTag(data) {
    return request({
        url: '/user/orderExpressTag',
        method: 'post',
        data: qs.stringify(data)
    })
}

//全部确认收货
export function orderState(data) {
    return request({
        url: '/user/orderState',
        method: 'post',
        data: qs.stringify(data)
    })
}

//订单列表—交易关闭的订单—取消原因
export function cancelOrderIndex(data) {
    return request({
        url: '/user/cancelOrderIndex',
        method: 'post',
        data: qs.stringify(data)
    })
}

//订单列表—交易关闭的订单—取消申请
export function cancelOrder(data) {
    return request({
        url: '/user/cancelOrder',
        method: 'post',
        data: qs.stringify(data)
    })
}

//订单列表—付款单列表
export function batchList(data) {
    return request({
        url: '/paymentbill/batchList',
        method: 'post',
        data: qs.stringify(data)
    })
}

//订单列表—付款单详情
export function detailBatchOrder(data) {
    return request({
        url: '/paymentbill/detailBatchOrder',
        method: 'post',
        data: qs.stringify(data)
    })
}

//订单列表—是否能够进行投诉
export function checkComplain(data) {
    return request({
        url: '/shopComplain/checkComplain',
        method: 'post',
        data: qs.stringify(data)
    })
}

//订单列表—获取投诉类型
export function complainIndex(data) {
    return request({
        url: '/shopComplain/complainIndex',
        method: 'post',
        data: qs.stringify(data)
    })
}

//订单列表—投诉提交
export function complainAdd(data) {
    return request({
        url: '/shopComplain/complainAdd',
        method: 'post',
        data: qs.stringify(data)
    })
}

//订单列表—投诉详情
export function detailByOrderSn(data) {
    return request({
        url: '/shopComplain/detailByOrderSn',
        method: 'post',
        data: qs.stringify(data)
    })
}

//订单列表—验证是否可以进行评论
export function checkEvaluateGoods(data) {
    return request({
        url: '/trade/evalGoods/checkEvaluateGoods',
        method: 'post',
        data: qs.stringify(data)
    })
}

//订单列表—评论提交
export function evaluateAdd(data) {
    return request({
        url: '/trade/evalGoods/evaluateAdd',
        method: 'post',
        data: qs.stringify(data)
    })
}

//订单列表—申请完结
export function applyComplete(data) {
    return request({
        url: '/user/applyComplete',
        method: 'post',
        data: qs.stringify(data)
    })
}

//订单列表—查看物流详情
export function findLogisticsNew(data) {
    return request({
        url: '/user/findLogisticsNew',
        method: 'post',
        data: qs.stringify(data)
    })
}

//订单列表—获取退货状态
export function preReturnOfGoods_Pre(data) {
    return request({
        url: '/user/preReturnOfGoods_Pre',
        method: 'post',
        data: qs.stringify(data)
    })
}

//订单列表—获取退货信息
export function preReturnOfGoods(data) {
    return request({
        url: '/user/preReturnOfGoods',
        method: 'post',
        data: qs.stringify(data)
    })
}

//订单列表—退换货附件上传
export function fileUploadRefund(data) {
    return request({
        url: '/user/fileUploadRefund',
        method: 'post',
        data: qs.stringify(data)
    })
}

//订单列表—退货提交
export function saveReturnOfGoods(data) {
    return request({
        url: '/user/saveReturnOfGoods',
        method: 'post',
        data: qs.stringify(data)
    })
}

//订单列表—获取换货状态
export function checkOrderTime(data) {
    return request({
        url: '/user/checkOrderTime',
        method: 'post',
        data: qs.stringify(data)
    })
}

//订单列表—换货信息获取
export function goSave(data) {
    return request({
        url: '/shopRefundBater/goSave',
        method: 'post',
        data: qs.stringify(data)
    })
}

//订单列表—换货信息附件上传
export function imageFileUpload(data) {
    return request({
        url: '/myReviews/imageFileUpload',
        method: 'post',
        data: qs.stringify(data)
    })
}

//订单列表—换货提交
export function baterSave(data) {
    return request({
        url: '/shopRefundBater/baterSave',
        method: 'post',
        data: qs.stringify(data)
    })
}
//确认收货
export function orderStateBatch(data) {
    return request({
        url: '/user/orderStateBatch',
        method: 'post',
        data: qs.stringify(data)
    })
}


// WEBPACK FOOTER //
// ./src/api/order.js